import type { JSX } from 'react';
import { Icon } from 'ts/components/Icon';
import type { ExtendedTrackedFinding } from 'typedefs/ExtendedTrackedFinding';

/**
 * Returns an icon based on the color. Used for displaying an icon corresponding to the severity of a Finding
 * assessment.
 */
export function AssessmentIcon({ finding }: { finding: ExtendedTrackedFinding }): JSX.Element | undefined {
	let icon;
	const color = finding.assessment;
	const ariaLabel = finding.assessment + ' Finding: ' + finding.message;
	switch (color) {
		case 'YELLOW':
			icon = (
				<Icon
					name="exclamation triangle"
					className="yellow"
					data-testid="assessment-icon"
					aria-label={ariaLabel}
				/>
			);
			break;
		case 'RED':
			icon = (
				<Icon name="remove circle" className="ts-red" data-testid="assessment-icon" aria-label={ariaLabel} />
			);
			break;
		default:
			icon = undefined; // No icon should be rendered
			break;
	}
	return icon;
}
